/***
 * 全局注册 常用组件
 */
// 搜索表单组件
import formQuery from "@/components/Form/formQuery";
// 表格组件
import Table from "@/components/TableRealy/BasicForm";
// 分页组件
// import Pagination from "@/components/pagination/Pagination";
// 功能按钮组件
import FuncBtns from "@/components/FuncBtn";
// 表单组件
const Form = () => import("@/components/Form/form");
// 当我们需要进行多个组件的注册时候, 假如说都写到main.js里面的话,
// 这样就会造成main.js文件的臃肿与杂乱
export default {
  install(Vue) {
    Vue.component("formQuery", formQuery);
    Vue.component("Table", Table);
    // Vue.component("Pagination", Pagination);
    Vue.component("FuncBtns", FuncBtns);
    Vue.component("Form", Form);
  }
};



// WEBPACK FOOTER //
// ./src/utils/useComponent.js